import { flagEnabled } from './featureFlags';

/**
 * Merge two or more ararys by object key
 * @param {String} key The property name to map off of
 * @param  {...Array<Object>} arrays The arrays to merge
 * @returns {Array<Object>} An array containing the first instance of each object matching `key`.
 */
export const mergeArraysBy = (key, ...arrays) => Array.from(arrays.reduce((map, array) => {
  (array || []).forEach((item) => {
    if (!map.has(item[key])) {
      map.set(item[key], item);
    }
  });
  return map;
}, new Map()).values());

const typesMap = {
  video: 'TV Box',
  internet: 'Internet & Voice Gateway',
  voice: 'Internet & Voice Gateway',
  home: 'Smart Home Controller',
  mobile: 'Mobile Device',
  storeFront: 'TV Box',
};

const headingMap = {
  video: 'TV',
  internet: 'Internet and Voice',
  voice: 'Internet & Voice Gateway',
  home: 'Home',
  mobile: 'Mobile',
  storeFront: 'TV & Streaming',
};

// Builds a map of serial numbers to device IDs from account data
const buildDeviceIdMap = (accountData = {}) => {
  const map = {};

  const services = accountData.services || {};

  Object.values(services).forEach((service) => {
    (service.devices || []).forEach((device) => {
      if (device.serialNumber && device.deviceId) {
        map[device.serialNumber] = device.deviceId;
      }
    });
  });

  return map;
};

export const transformServices = ({
  dsmDevices = {},
  returns,
  accountData = {},
}) => {
  const services = [];
  const devices = {};
  if (!Object.keys(dsmDevices).length) {
    return { services, devices };
  }
  const deviceIdMap = buildDeviceIdMap(accountData);
  const returnSerials = [];

  const enableHomeDevices = flagEnabled('device-returns.enableHomeDevices', { defaultValue: true });

  const {
    internet = [],
    voice = [],
  } = dsmDevices;
  // We need to merge internet and voice so that we capture any devices from the voice object
  const internetAndVoiceDevices = mergeArraysBy(
    'serialNumber',
    internet,
    voice,
  );

  Object.keys(dsmDevices).forEach((lob) => {
    if (lob === 'voice') return;
    const devs = (
      lob === 'internet'
        ? internetAndVoiceDevices
        : (dsmDevices[lob] || [])
    )
      .filter(({
        isSubscriberOwned,
        serialNumber,
      }) => !isSubscriberOwned && returnSerials.indexOf(serialNumber) === -1)
      .map(({
        serialNumber,
        ...device
      }) => ({
        ...device,
        lob,
        type: typesMap[lob],
        description: device.description,
        image: device.image,
        activationStatus: device.deviceStatus,
        serialNumber,
        modelCode: device.modelCode,
        isSubscriberOwned: device.isSubscriberOwned,
        deviceId: deviceIdMap[serialNumber],
      }));
    if (!devs.length) return;
    devs.forEach((device) => {
      devices[device.serialNumber] = device;
    });

    services.push({
      devices: devs,
      name: lob,
      viewName: lob.charAt(0).toUpperCase() + lob.slice(1),
      heading: headingMap[lob],
      returnable: enableHomeDevices || lob !== 'home',
    });
  });
  return { services, devices };
};
